import CustomerStateActions, {CustomerStateActionNames} from "app/actions/customerState.actions";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import CustomerSearchService from "external-services/customer-search-service";
import { CustomerGeneratorService } from "external-services/customer-generator-service";
import CustomerLookupService from 'external-services/customer-lookup-service';

const NS = 'CustomersCtrl';


export default function CustomersCtrl(
  $rootScope, $scope, $window, $localStorage, $mdDialog,
  $filter,  pouchService, unregister
) {
  "ngInject";

  const Pagination = function () {
    this.marker = Math.random();
    /** @type {boolean} Mark first load */
    this.initialized = false;
    /** @type {!Object<?Array>} Data pages, keyed by page number (0-index) */
    this.loadedPages = {};
    /** @type {number} Total number of items. */
    this.numItems = 0;
    /** @const {number} Number of items to fetch per request. */
    this.PAGE_SIZE = 50;
    // ?? Init
    this.fetchNumItems_();
  };

  Pagination.prototype.getItemAtIndex = function (index) {
    // console.log('getItemAtIndex', index);
    var pageNumber = Math.floor(index / this.PAGE_SIZE);
    var page = this.loadedPages[pageNumber];

    if (page) {
      return page[index % this.PAGE_SIZE];
    } else if (page !== null) {
      this.fetchPage_(pageNumber);
    }
  };

  Pagination.prototype.getLength = function () {
    // console.log('getLength', this.numItems);
    return this.numItems;
  };

  Pagination.prototype.fetchPage_ = function (pageNumber) {
    // console.log('fetchPage_', this.marker, pageNumber);
    // Set the page to null so WR know it is already being fetched
    this.loadedPages[pageNumber] = null;

    var params = getSearchParams();
    params.start = pageNumber * this.PAGE_SIZE;
    params.count = this.PAGE_SIZE;
    CustomerSearchService.search(params).then(result => {
      var extendeds = result.items.map(customer => {
        customer.displayName = CustomerGeneratorService.getDisplayName(customer);
        return customer;
      });
      this.loadedPages[pageNumber] = extendeds;
    }).catch(() => {
      this.loadedPages = [];
      this.numItems = 0;
    });
  };

  Pagination.prototype.fetchNumItems_ = function () {
    var params = getSearchParams();
    params.start = 0;
    params.count = this.PAGE_SIZE;

    CustomerSearchService.search(params).then(result => {
      this.initialized = true;
      this.numItems = result.count;
      var extendeds = result.items.map(customer => {
        customer.displayName = CustomerGeneratorService.getDisplayName(customer);
        // customer.permanentTags = -(customer.tags || []).filter(t => t.permanent).length;
        return customer;
      });
      this.loadedPages[0] = extendeds;
      // console.log('fetchNumItems_', this.marker, this.numItems);
    }).catch(() => {
      // console.err('fetchNumItems_', this.marker);
      this.initialized = true;
      this.numItems = 0;
    });
  };

  var vm = this;

  vm.isManager = ManagerService.isManager;
  vm.sortReversed = false;
  vm.sortBy = 'lastName';
  vm.sortOptions = [{
    value: 'firstName',
    label: 'First name'
  }, {
    value: 'lastName',
    label: 'Last name'
  }, {
    value: 'phone',
    label: 'Phone'
  }, {
    value: 'email',
    label: 'Email'
  }, {
    value: 'company',
    label: 'Company'
  }, {
    value: 'permanentTags',
    label: 'Tags'
  }];

  vm.newCustomer = newCustomer;
  vm.editCustomer = editCustomer;
  vm.exportCustomer = exportCustomer;
  vm.updateCustomers = updateCustomers;
  vm.shouldPerformSearch = shouldPerformSearch;
  vm.isOffline = !NetworkConnectionService.isOnline();

  //-- listen
  var listeners = [];
  // listeners.push($rootScope.$on('customers-change', updateCustomers));
  listeners.push(CustomerStateActions.handleCustomerStateAction(CustomerStateActionNames.CUSTOMERS_CHANGE, updateCustomers));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  function newCustomer(evt) {
    $mdDialog.show({
      controller: 'NewCustomerCtrl',
      controllerAs: 'newCustomer',
      clickOutsideToClose: true,
      templateUrl: 'app/customers/new/newCustomer.html',
      targetEvent: evt,
      onComplete: function ($scope) {
        $scope.newCustomer.showComplete = true;
      }
    });
  }

  function editCustomer(evt, customer) {
    updateOfflineStatus();

    CustomerLookupService.getById(customer._id).then((_customer) => {

      if (_customer) {
        customer.managerNotes = _customer.managerNotes;
      }

      openCustomerModal(evt, _customer);
    });
  }

  function openCustomerModal(evt, customer) {
      $mdDialog.show({
        controller: 'EditCustomer',
        controllerAs: 'editCustomer',
        clickOutsideToClose: true,
        templateUrl: 'app/customers/edit/editCustomer.html',
        targetEvent: evt,
        onComplete: function ($scope) {
          $scope.editCustomer.showComplete = true;
        },
        locals: {
          customer: customer,
          isOffline: vm.isOffline,
          handleNewCustomerSelected: null,
        }
      });
  }


  function exportCustomer(evt) {
    $mdDialog.show({
      controller: 'ExportCustomerCtrl',
      controllerAs: 'exportCustomer',
      clickOutsideToClose: true,
      templateUrl: 'app/customers/export/exportCustomer.html',
      targetEvent: evt
    });
  }

  function shouldPerformSearch(){
    if(!vm.searchStr || vm.searchStr.length < 3)
      return false;

    const isNumber = !isNaN(vm.searchStr);
    const minLength = vm.searchStr.startsWith("04") || vm.searchStr.startsWith("02")  ? 5 : 3;

    return isNumber ? vm.searchStr.length >= minLength : true;
  }

  function updateCustomers() {
    vm.pagination = null;
    if(!shouldPerformSearch()){
      return;
    }

    setTimeout(() => {
      vm.pagination = new Pagination();
    }, 200);
  }

  function getSearchParams() {
    var params = {};

    if (vm.searchStr) {
      params.q = vm.searchStr;
    }

    if (vm.sortBy) {
      params.sort = (vm.sortReversed ? '-' : '') + vm.sortBy;
    }

    return params;
  }

  function updateOfflineStatus() {
    // if connection has already been lost, status isn't changed
    if (AdminService.getVenue().isOnlineCustomersEnabled && !NetworkConnectionService.isOnline()) {
      vm.isOffline = true;
    }
  }
}
